import http from "infra/http";
import { useQuery } from "react-query";
import { PastaItem } from "../typings";
import { UsePastasParams } from "./../typings/index";

function usePastas({
  pastaPaiId,
  gruposUnidadesIds,
  unidadesIds,
}: UsePastasParams) {
  return useQuery(
    [
      `/v1/documento/pastas?documentoPaiId=${pastaPaiId}`,
      gruposUnidadesIds,
      unidadesIds,
    ],
    async () => {
      const { data } = await http.get<PastaItem[]>(`/v1/documento/pastas`, {
        params: {
          documentoPaiId: pastaPaiId,
          gruposUnidadesIds,
          unidadesIds,
        },
      });

      return data;
    }
  );
}

export default usePastas;
